import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import ApiService from 'services/ApiService';

import { Style, Icon } from 'ol/style.js';
import { ToFeatures } from 'services/GeoJsonService';

export default class LayerPointPin extends VectorLayer {

    constructor(map) {
        super({
            name: 'pointPinLayer',
            source: new VectorSource(),
            style: (feature) => this.getDefaultStyle(feature),
        });
        this.map = map;
        this.map?.addLayer(this);
        this.setData();
    }

    setData = function () {
        const layer = this;
        //   위도 경도
        // 수원시청	37.2634727	127.0286748
        // 교통센터	37.2993059	127.0481924
        // 컨벤션센터	37.2857663	127.0593936
        // 아주대병원	37.2793947	127.0475017
        // 수원역	37.2662694	127.0000253
        // 망포역	37.2458512	127.0574192
        // 성균관대역	37.3003092	126.9710329

        let dataset = new Array();
        let id, name, x, y, obj;

        obj = { 
            id: 'poi_1', 
            x: 127.0286748, 
            y: 37.2634727, 
            nm: '수원시청',
            type: "poi", 
        };
        dataset.push(obj);

        obj = { 
            id: 'poi_2', 
            x: 127.0481924, 
            y: 37.2993059, 
            nm: '교통센터',
            type: "poi", 
        };
        dataset.push(obj);

        obj = { 
            id: 'poi_3', 
            x: 127.0593936, 
            y: 37.2857663, 
            nm: '컨벤션센터',
            type: "poi", 
        };
        dataset.push(obj);

        obj = { 
            id: 'poi_4', 
            x: 127.0475017, 
            y: 37.2793947, 
            nm: '아주대병원',
            type: "poi", 
        };

        dataset.push(obj);
                obj = { 
            id: 'poi_5', 
            x: 127.0000253, 
            y: 37.2662694, 
            nm: '수원역',
            type: "poi", 
        };

        dataset.push(obj);
                obj = { 
            id: 'poi_6', 
            x: 127.0574192, 
            y: 37.2458512, 
            nm: '망포역',
            type: "poi", 
        };

        dataset.push(obj);
                obj = { 
            id: 'poi_7', 
            x: 126.9710329, 
            y: 37.3003092, 
            nm: '성균관대역',
            type: "poi", 
        };
        dataset.push(obj);

        const source = this.getSource()
        source.addFeatures(ToFeatures(dataset))
    }

    getDefaultStyle = (feature) => {
        const id = feature.get('properties')?.id ;
        return new Style({
            image: new Icon({
                anchor: [0.5, 0.5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: `/images/facility/${id}.svg`,
                scale: 0.8,
            }),
            zIndex: 1,
        })
    };
}